import { Button, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
const ChangeBackgroundButton: React.FC<any> = ({ setBackgourndSrc }) => {
  const { t } = useTranslation();
  const ChangeBackground = (e: React.ChangeEvent<HTMLInputElement>) => {
    //追加画像変更用function。JSXから呼び出される最初のやつ
    if (e.target.files === null) return;
    const img: Blob = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(img);
    reader.onload = () => {
      const res: string | ArrayBuffer | null = reader.result; //
      setBackgourndSrc(res);
    };
  };
  return (
    <Grid item>
      <label>
        <input
          type="file"
          accept="image/png,image/jpeg"
          onChange={ChangeBackground}
          style={{ display: "none" }}
        ></input>
        <Button variant="contained" component="span" color="primary" fullWidth>
          {t("actionButtons.changeBackgroundButton")}
        </Button>
      </label>
    </Grid>
  );
};
export default ChangeBackgroundButton;
